// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__3T_fo","dynamicTitle":"Home_dynamicTitle__2-GJ4","dynamicHeader":"Home_dynamicHeader__1um38","dynamicHeaderh3":"Home_dynamicHeaderh3__L98BW"};